export default class InvalidLuxonDateError extends Error {
  /**
   * Represents an invalid Luxon date.
   * @constructor
   * @param {string} input the DateTime input
   * @param {string} invalidReason an error code
   * @param {string} invalidExplanation  an explanation of why the DateTime became invalid
   */
  constructor(input, invalidReason, invalidExplanation) {
    const message = `${input} (Reason: ${invalidReason}, Explanation: ${invalidExplanation})`;
    super(message);
    this.name = 'InvalidLuxonDateError';
    this.input = input;
    this.invalidReason = invalidReason;
    this.invalidExplanation = invalidExplanation;
  }
}
